import SiteHeaderMobile from './SiteHeaderMobile';
import SiteHeaderMobileContainer from './SiteHeaderMobile.container';

export default SiteHeaderMobileContainer(SiteHeaderMobile);
